import React from 'react';

const spinnerStyle: React.CSSProperties = {
  display: 'inline-block',
  width: 24,
  height: 24,
  border: '3px solid #e0e0e0',
  borderTop: '3px solid #4b1583',
  borderRadius: '50%',
  animation: 'bik-spin 1s linear infinite',
};

const styleSheet = `@keyframes bik-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;

interface SpinnerProps {
  color?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ color }) => (
  <>
    <style>{styleSheet}</style>
    <span
      style={{ ...spinnerStyle, borderTopColor: color }}
      aria-label="Loading"
    />
  </>
);

export default Spinner;
